"use client";

import { LoaderCircle } from "lucide-react";
import { useMemo } from "react";

export function StatusBar({
  markdown,
  pageCount,
  isUpdating = false,
}: Readonly<{
  markdown: string;
  pageCount: number;
  isUpdating?: boolean;
}>) {
  const { words, characters } = useMemo(() => {
    const trimmed = markdown.trim();
    const characters = trimmed.length;
    const words = characters === 0 ? 0 : trimmed.split(/\s+/).length;

    return { words, characters };
  }, [markdown]);

  return (
    <div className="status-bar grid shrink-0 grid-cols-[1fr_auto_1fr] items-center gap-3 border-t px-3 py-1.5 text-xs">
      <span className="truncate">
        {words.toLocaleString()} word{words === 1 ? "" : "s"}
        {" "}
        ·
        {" "}
        {characters.toLocaleString()} character{characters === 1 ? "" : "s"}
      </span>
      <span className="justify-self-center">
        {isUpdating ? (
          <span
            data-testid="status-updating"
            className="inline-flex items-center gap-1"
            role="status"
          >
            <LoaderCircle
              aria-hidden="true"
              className="size-3 animate-spin text-brand"
            />
            Rendering
          </span>
        ) : null}
      </span>
      <span
        className="justify-self-end truncate"
        aria-busy={isUpdating || undefined}
      >
        {pageCount.toLocaleString()} page{pageCount === 1 ? "" : "s"}
      </span>
    </div>
  );
}
